// extracted by mini-css-extract-plugin
export default {"advancedSettingsContainer":"AdvanceSettings_advancedSettingsContainer__NpbHb","heading":"AdvanceSettings_heading__P6OSH"};